module.exports = __webpack_public_path__ + "img/fig06.64b9424e.jpg";